// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hero comes from the shared .page-hero rule in AboutUs.css. Olive is the
   shared --color-olive (see BusyBees.css for its contrast numbers). */
.programs-page {
  --programs-olive: var(--color-olive);
  --programs-panel: #e9eed6;
  --programs-chip: #f6dfd8; /* blush washed toward white; carries icons only */
}

.programs-list {
  max-width: 900px;
  display: grid;
  gap: 16px;
}

.program-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: center;
  background-color: var(--surface-raised);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
  padding: 24px;
  box-shadow: var(--shadow-soft);
}

/* Every other card puts the checklist on the left. */
.program-card:nth-child(even) .program-text {
  order: 2;
}

.program-text h2 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  font-size: 1.5rem;
  color: var(--programs-olive);
  margin: 14px 0 10px;
}

.program-text p {
  margin: 0;
  font-size: 0.95rem;
}

.program-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-md);
  background-color: var(--programs-chip);
  color: var(--text-accent);
}

/* Coral fill needs the ink-deep label, as on the site's buttons. */
.program-badge {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  background-color: var(--interactive-default);
  color: var(--interactive-label);
  padding: 3px 10px;
  border-radius: 999px;
}

.program-highlights {
  list-style: none;
  margin: 0;
  padding: 20px;
  display: grid;
  gap: 10px;
  background-color: var(--programs-panel);
  border-radius: var(--radius-md);
  font-size: 0.95rem;
}

.program-highlights li {
  display: flex;
  align-items: center;
  gap: 10px;
}

.program-check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: var(--interactive-default);
  color: var(--interactive-label);
}

/* --- CTA ------------------------------------------------------------------ */
.programs-cta {
  background-color: var(--programs-olive);
  color: var(--color-cream);
  border-radius: var(--radius-lg);
  padding: 36px 24px;
  text-align: center;
}

.programs-cta h2 {
  color: var(--color-white);
  margin-bottom: 8px;
}

.programs-cta p {
  margin: 0;
}

.programs-cta-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 22px;
}

.programs-cta-actions .btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.programs-btn-ghost,
.programs-btn-ghost:visited {
  display: inline-block;
  color: var(--color-white);
  font-weight: 600;
  padding: 12px 28px;
  border-radius: 999px;
  border: 2px solid var(--color-cream);
  transition: background-color 0.15s ease;
}

.programs-btn-ghost:hover {
  background-color: rgba(255, 255, 255, 0.1);
  text-decoration: none;
}

.programs-cta :focus-visible {
  outline-color: var(--color-cream);
}

@media (max-width: 780px) {
  .program-card {
    grid-template-columns: 1fr;
  }

  /* Stacked, the description always comes before its checklist. */
  .program-card:nth-child(even) .program-text {
    order: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Programs.css"],"names":[],"mappings":"AAAA;sEACsE;AACtE;EACE,oCAAoC;EACpC,yBAAyB;EACzB,wBAAwB,EAAE,kDAAkD;AAC9E;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,uCAAuC;EACvC,sCAAsC;EACtC,+BAA+B;EAC/B,aAAa;EACb,8BAA8B;AAChC;;AAEA,qDAAqD;AACrD;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,aAAa;EACb,SAAS;EACT,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA,+EAA+E;AAC/E;EACE,uCAAuC;EACvC,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA,gEAAgE;EAChE;IACE,QAAQ;EACV;AACF","sourcesContent":["/* Hero comes from the shared .page-hero rule in AboutUs.css. Olive is the\n   shared --color-olive (see BusyBees.css for its contrast numbers). */\n.programs-page {\n  --programs-olive: var(--color-olive);\n  --programs-panel: #e9eed6;\n  --programs-chip: #f6dfd8; /* blush washed toward white; carries icons only */\n}\n\n.programs-list {\n  max-width: 900px;\n  display: grid;\n  gap: 16px;\n}\n\n.program-card {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  align-items: center;\n  background-color: var(--surface-raised);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-lg);\n  padding: 24px;\n  box-shadow: var(--shadow-soft);\n}\n\n/* Every other card puts the checklist on the left. */\n.program-card:nth-child(even) .program-text {\n  order: 2;\n}\n\n.program-text h2 {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  font-size: 1.5rem;\n  color: var(--programs-olive);\n  margin: 14px 0 10px;\n}\n\n.program-text p {\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n.program-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-md);\n  background-color: var(--programs-chip);\n  color: var(--text-accent);\n}\n\n/* Coral fill needs the ink-deep label, as on the site's buttons. */\n.program-badge {\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  background-color: var(--interactive-default);\n  color: var(--interactive-label);\n  padding: 3px 10px;\n  border-radius: 999px;\n}\n\n.program-highlights {\n  list-style: none;\n  margin: 0;\n  padding: 20px;\n  display: grid;\n  gap: 10px;\n  background-color: var(--programs-panel);\n  border-radius: var(--radius-md);\n  font-size: 0.95rem;\n}\n\n.program-highlights li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.program-check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background-color: var(--interactive-default);\n  color: var(--interactive-label);\n}\n\n/* --- CTA ------------------------------------------------------------------ */\n.programs-cta {\n  background-color: var(--programs-olive);\n  color: var(--color-cream);\n  border-radius: var(--radius-lg);\n  padding: 36px 24px;\n  text-align: center;\n}\n\n.programs-cta h2 {\n  color: var(--color-white);\n  margin-bottom: 8px;\n}\n\n.programs-cta p {\n  margin: 0;\n}\n\n.programs-cta-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 22px;\n}\n\n.programs-cta-actions .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.programs-btn-ghost,\n.programs-btn-ghost:visited {\n  display: inline-block;\n  color: var(--color-white);\n  font-weight: 600;\n  padding: 12px 28px;\n  border-radius: 999px;\n  border: 2px solid var(--color-cream);\n  transition: background-color 0.15s ease;\n}\n\n.programs-btn-ghost:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n  text-decoration: none;\n}\n\n.programs-cta :focus-visible {\n  outline-color: var(--color-cream);\n}\n\n@media (max-width: 780px) {\n  .program-card {\n    grid-template-columns: 1fr;\n  }\n\n  /* Stacked, the description always comes before its checklist. */\n  .program-card:nth-child(even) .program-text {\n    order: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
